// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Z69eh","inner":"Footer_inner__2q58y","nextIcon":"Footer_nextIcon__1ZBRB","innerLeft":"Footer_innerLeft__1yStB"};